var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-dropdown-container" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.handleFocusOut,
            expression: "handleFocusOut"
          }
        ],
        class: "k-dropdown " + (_vm.error ? "-error" : "")
      },
      [
        _c("div", { staticClass: "externalOverlay" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-select-container" },
          [
            _c(
              "div",
              {
                staticClass: "c-select",
                attrs: { tabindex: "0" },
                on: {
                  click: _vm.handleClick,
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.handleFocusOut.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "content" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.label))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "not-display",
                    attrs: {
                      name: "k-input",
                      type: "text",
                      autocomplete: "nope"
                    },
                    domProps: { value: _vm.value }
                  }),
                  _vm._v(" "),
                  _vm.isOpened
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search"
                          }
                        ],
                        ref: "search",
                        staticClass: "dropdown-button",
                        attrs: {
                          "aria-label": _vm.placeholder,
                          type: "text",
                          autocomplete: "nope",
                          name: "k-input"
                        },
                        domProps: { value: _vm.search },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value
                          }
                        }
                      })
                    : _c("input", {
                        staticClass: "dropdown-button",
                        class: !_vm.choosedOption ? "-placeholder" : "",
                        attrs: {
                          "aria-label": _vm.placeholder,
                          type: "text",
                          autocomplete: "nope",
                          name: "k-input"
                        },
                        domProps: {
                          value: _vm.choosedOption || _vm.placeholder
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isOpened && _vm.search.length === 0,
                          expression: "isOpened && search.length === 0"
                        }
                      ],
                      staticClass: "false-placeholder"
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.placeholder) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("k-icon", {
                  class: "icon " + (_vm.isOpened ? "-opened" : ""),
                  attrs: { "icon-color": "#323232", icon: "arrow-down1" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-down" } }, [
              _vm.isOpened
                ? _c(
                    "div",
                    { staticClass: "options" },
                    _vm._l(_vm.filteredOptions, function(option) {
                      return _c(
                        "div",
                        {
                          key: option.value,
                          staticClass: "option",
                          attrs: { value: option.value },
                          on: {
                            click: function($event) {
                              return _vm.chooseOption(option)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.label) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "k-dropdown-feedback" }, [
      _vm.error
        ? _c("span", [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-565c48fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565c48fb","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KDropdown.vue
// module id = 2050
// module chunks = 1610